<script setup>
import { Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/vue"
import { ref, watch } from "vue"
import SectionVideo from "@/Components/SectionVideo.vue"
import SwButtons from "@/Components/ui/SwButtons.vue"
import SectionPosition from "@/Components/SectionPosition.vue"

const modules = [Navigation, Pagination]

const props = defineProps({
	page: Object
})
</script>

<template>
	<Page :description="page.title" :image="page.image" :title="page.name">
		<SectionVideo :poster="page.image" :subtitle="page.subtitle" :title="page.title" :video="page.video_file" />
		<template v-for="(item, index) in page.bricks" :key="index">
			<section v-if="item.data.is_active">
				<div class="w-container padding-y relative bg-white">
					<SectionPosition v-if="item.type === 'text-slider'" position="between">
						<template v-if="item.data.subtitle" v-slot:left-subtitle>{{ item.data.subtitle }}</template>
						<template v-slot:left-content>
							<p v-if="item.data.title" class="heading-xl font-heading">{{ item.data.title }}</p>
							<p v-if="item.data.excerpt">
								{{ item.data.excerpt }}
							</p>
						</template>
						<template v-slot:right>
							<div v-if="item.data.gallery?.slides?.length > 0">
								<swiper
									v-if="item.data.gallery.uuid === 'gallery-why-omd'"
									:modules="modules"
									:navigation="{ prevEl: '.sw-prev', nextEl: '.sw-next' }"
									:pagination="{ clickable: true }"
									:scrollbar="{ draggable: true }"
									:slides-per-view="1"
									:space-between="50"
									class="swiper-primary"
								>
									<swiper-slide v-for="(slide, i) in item.data.gallery.slides" :key="i">
										<div v-if="slide.image" class="aspect-video">
											<img :src="'/storage/' + slide.image" alt="" />
										</div>
									</swiper-slide>
									<SwButtons />
								</swiper>
								<swiper
									v-if="item.data.gallery.uuid === 'gallery-reviews'"
									:modules="modules"
									:navigation="{ prevEl: '.sw-prev', nextEl: '.sw-next' }"
									:pagination="false"
									:scrollbar="{ draggable: true }"
									:slides-per-view="1"
									:space-between="10"
									class="swiper-primary"
								>
									<swiper-slide v-for="(slide, i) in item.data.gallery.slides" :key="i">
										<div class="review overflow-hidden bg-white pb-5 pt-10 md:px-5 md:pt-20">
											<div v-if="slide.excerpt" class="mb-5 text-base font-semibold text-accent md:text-2xl" v-html="slide.excerpt"></div>
											<img v-if="slide.image" :src="'/storage/' + slide.image" alt="" class="mb-5 h-10 w-24 object-contain md:h-24 md:w-40" />
										</div>
									</swiper-slide>
									<!--								<SwButtons />-->
								</swiper>
								<swiper
									v-if="item.data.gallery.uuid === 'gallery-media-agency'"
									:modules="modules"
									:navigation="{ prevEl: '.sw-prev', nextEl: '.sw-next' }"
									:pagination="true"
									:scrollbar="{ draggable: true }"
									:slides-per-view="1"
									:space-between="10"
									class="swiper-primary"
								>
									<swiper-slide v-for="(slide, i) in item.data.gallery.slides" :key="i">
										<div class="review overflow-hidden bg-white pb-5 pt-10 md:px-5 md:pt-20">
											<div v-if="slide.excerpt" class="mb-5 text-base font-semibold text-accent md:text-2xl" v-html="slide.excerpt"></div>
											<img v-if="slide.image" :src="'/storage/' + slide.image" alt="" class="mb-5 w-full object-contain" />
										</div>
									</swiper-slide>
									<!--								<SwButtons />-->
								</swiper>
								<swiper
									v-if="item.data.gallery.uuid === 'gallery-platform'"
									:modules="modules"
									:navigation="{ prevEl: '.sw-prev', nextEl: '.sw-next' }"
									:pagination="true"
									:scrollbar="{ draggable: true }"
									:slides-per-view="1"
									:space-between="10"
									class="swiper-primary"
								>
									<swiper-slide v-for="(slide, i) in item.data.gallery.slides" :key="i">
										<div v-if="slide.image !== null" class="review overflow-hidden bg-white pb-5 pt-10 md:px-5 md:pt-20">
											<img :src="'/storage/' + slide.image" alt="" class="mb-5 w-full object-contain" />
										</div>
									</swiper-slide>
									<!--								<SwButtons />-->
								</swiper>
							</div>
						</template>
					</SectionPosition>
				</div>
			</section>
		</template>
	</Page>
</template>

<style lang="scss" scoped>
.review {
	@apply relative;
	&:after {
		content: "";
		@apply absolute left-0 top-0 h-px w-full bg-black;
	}
}
</style>
